import BookShow from "components/shared/book/show";
import { viewContainer } from "helpers/redux";
import React, { lazy, Suspense } from "react";
import { config, initialState } from "../formConfig";

const Editor = lazy(() => import("components/shared/editor.js"));

class ShowPopupTemplate extends BookShow {
    get dropdActions() {
        return [{ text: "Удалить", action: this.actionClose }];
    }

    renderBody = () => {
        const { config } = this.props;
        const { organizationIds, text } = this.state.data;
        return (
            <>
                {this.renderField(config.header)}
                <Suspense fallback={<div className="loading" />}>
                    <Editor value={text} onChange={(value) => this.setValue({ name: "text", value })} />
                </Suspense>
                {this.renderCheckbox(config.noWayToClose)}
                {this.renderCheckbox(config.forWhiteListOrganizations)}
                {this.renderField(config.countOfExpiredDays)}
                {this.renderField(config.daysBeforeSubscriptionExpires)}
                {this.renderField(config.daysUntilBlocking)}
                {this.renderSelect(config.moduleType)}
                {this.renderSelect(config.organizationIds)}
                {this.renderSelect({ ...config.roles, disabled: !organizationIds?.length })}
                {this.renderButton()}
            </>
        );
    };
}

const ConfiguredShow = (props) => <ShowPopupTemplate {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "popup-templates");
